import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row"; // Import separately for the new version
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    singleData: any;
    open: boolean | undefined;
    hideDialog: () => void;
    toast: any;
}

export const SubTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [heading, setHeading] = useState<string>('');
    const dt = useRef<any>();

    const loadData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch(
            "WorkInProgressReports/getSubList",
            "GET",
            null,
            `filter=${JSON.stringify(props.singleData.filter)}&vendor_Company_ID=${props.singleData.singleData.vendor_Company_ID}`,
            props.toast
        );
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center flex justify-content-between bg-white">
            <h5 className="m-0">{heading}</h5>
        </div>
    );

    useEffect(() => {
        if (props.open) loadData();
        if (props.singleData.type === "Req") setHeading("Requirement Wise PV Performance Report");
        if (props.singleData.type === "Sub") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "SubClient") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "ECI") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "PO") setHeading("Prime Vendor Submission Report");
    }, [props.open]);

    // Define column groups
    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="General Info" colSpan={4} />
                <Column header="Last Month" colSpan={5} className="bg-cyan-100" />
                <Column header="Till Month" colSpan={5} className="bg-green-200" />
                <Column header="Today's Data" colSpan={5} className="bg-yellow-200" />
            </Row>
            <Row>
            <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} footer={""} />
                <Column field="vendor_Company_Name" header="Prime Vendor" />
                <Column field="user_Name" header="Sales Manager" />
                <Column field="branchName" header="Branch Name" />
                <Column field="totalReq" header="Req" className="bg-cyan-100"  />
                <Column field="totalSub" header="Sub" className="bg-cyan-100" />
                <Column field="totalSubEnd" header="ECS" className="bg-cyan-100" />
                <Column field="eciTotal" header="ECI" className="bg-cyan-100"  />
                <Column field="totalPO" header="PO" className="bg-cyan-100" />
                <Column field="totalReqMonth" header="Req" className="bg-green-200"/>
                <Column field="monthSub" header="Sub" className="bg-green-200"/>
                <Column field="monthSubEnd" header="ECS" className="bg-green-200"/>
                <Column field="eciMonth" header="ECI" className="bg-green-200"/>
                <Column field="totalPOM" header="PO " className="bg-green-200"/>
                <Column field="totalReqToday" header="Req" className="bg-yellow-200" />
                <Column field="todaySub" header="Sub" className="bg-yellow-200" />
                <Column field="todaySubEnd" header="ECS" className="bg-yellow-200" />
                <Column field="eciToday" header="ECI" className="bg-yellow-200" />
                <Column field="totalPOT" header="PO" className="bg-yellow-200" />
            </Row>
        </ColumnGroup>
    );

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="" modal className="p-fluid" onHide={onHide}>
            <DataTable
                style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns
                ref={dt}
                size="small"
                scrollable
                scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                headerColumnGroup={headerGroup}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} footer={""} />
                <Column field="vendor_Company_Name" header="Prime Vendor" />
                <Column field="user_Name" header="Sales Manager" />
                <Column field="branchName" header="Branch Name" />
                <Column field="totalReq" header="Req" />
                <Column field="totalSub" header="Sub" />
                <Column field="totalSubEnd" header="ECS" />
                <Column field="eciTotal" header="ECI" />
                <Column field="totalPO" header="PO" />
                <Column field="totalReqMonth" header="Req " />
                <Column field="monthSub" header="Sub " />
                <Column field="monthSubEnd" header="ECS" />
                <Column field="eciMonth" header="ECI" />
                <Column field="totalPOM" header="PO" />
                <Column field="totalReqToday" header="Req" />
                <Column field="todaySub" header="Sub" />
                <Column field="todaySubEnd" header="ECS" />
                <Column field="eciToday" header="ECI" />
                <Column field="totalPOT" header="PO" />
                {/* Columns are now defined in headerGroup */}
            </DataTable>
        </Dialog>
    );
};
